import {STORAGE_KEY_PREFIX} from "@/config/config";

export let SaveItem = function (key, value) {
    let fullKey = STORAGE_KEY_PREFIX + key;
    try {
        window.localStorage.setItem(fullKey, value);
    } catch (e) {
        //
    }
};

export let GetItem = function (key, defaults) {
    let fullKey = STORAGE_KEY_PREFIX + key;
    try {
        let val = window.localStorage.getItem(fullKey);
        if (val) {
            return val;
        }
        if (defaults) {
            return defaults;
        }
        return null;
    } catch (e) {
        if (defaults) {
            return defaults;
        }
    }
    return null;
};

export let ClearItem = function (key) {
    let fullKey = STORAGE_KEY_PREFIX + key;
    try {
        return window.localStorage.removeItem(fullKey);
    } catch (e) {
        //
    }
    return null;
}